import { Dispatch } from "redux";
import {
    getCardStatement,
    getBlockedIbanService,
    getAccounts,
    getRequisite,
    getCardStatementByPan
} from '../../../services/account';
import { CardStatementAction, CardStatementActionTypes } from "../../types/cardStatement";




export const getCardStatementData = (payload: any) => {
    const { company, formData, otp } = payload;

    return (dispatch: Dispatch<CardStatementAction>) => {
        console.log(formData)

        // 1. resolve və reject parametrlərini bura əlavə edirik
        return new Promise((resolve, reject) => {
            
            dispatch({ type: CardStatementActionTypes.GET_CARDS_STATEMENT_REQUEST })

            if (formData.ibanRef !== "" && formData.ibanRef !== null && formData.ibanRef !== undefined) {
                
                getCardStatement(company, { ...formData, otp })
                    .then(response => {
                        dispatch({
                            payload: {
                                result: response.IB4C_Statement_by_Card_IBAN_Resp,
                            },
                            type: CardStatementActionTypes.GET_CARDS_ACCOUNT_STATEMENT_SUCCESS,
                        })
                        // 2. Uğurlu cavab gəldikdə resolve edirik
                        resolve(response);
                    })
                    .catch((error: any) => {
                        dispatch({
                            error: {
                                result: error.response,
                            },
                            type: CardStatementActionTypes.GET_CARDS_STATEMENT_ERROR,
                        })
                        // 3. Xəta gəldikdə reject edirik ki, try-catch bunu tutsun
                        reject(error.response || error);
                    })
            } else {
                dispatch({
                    payload: {
                        result: [],
                    },
                    type: CardStatementActionTypes.GET_CARDS_ACCOUNT_STATEMENT_SUCCESS,
                })
                // 4. İban yoxdursa boş nəticə ilə bitiririk
                resolve([]);
            }
        })
    }
}
export const getCardStatementDataByPan = (payload: any) => {
  const { company, formData, otp } = payload;
  
  return (dispatch: Dispatch<CardStatementAction>) => {
    // resolve və reject parametrlərini əlavə edirik
    return new Promise((resolve, reject) => {
      dispatch({ type: CardStatementActionTypes.GET_CARDS_STATEMENT_REQUEST });

      if (formData.pan !== "" && formData.pan !== null && formData.pan !== undefined) {
        getCardStatementByPan(company, formData, otp)
          .then(response => {
            dispatch({
              payload: { result: response?.IB4C_Statement_by_PAN_Resp },
              type: CardStatementActionTypes.GET_CARDS_STATEMENT_SUCCESS,
            });
            resolve(response); // Uğurlu olduqda Promise-i bitir
          })
          .catch((error: any) => {
            dispatch({
              error: { result: error.response },
              type: CardStatementActionTypes.GET_CARDS_STATEMENT_ERROR,
            });
            reject(error.response || error); // Xəta olduqda reject et ki, catch-ə düşsün!
          });
      } else {
        dispatch({
          payload: { result: [] },
          type: CardStatementActionTypes.GET_CARDS_STATEMENT_SUCCESS,
        });
        resolve([]); // Boş data ilə bitir
      }
    });
  }
}

export const setFilterData = (value:object) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_CARDS_STATEMENT_FILTER,
            payload: value
        })
    }
}
export const setCardArray = (value:object) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_CARD_ARRAY,
            payload: value
        })
    }
}
export const setCardAccountsArray = (value:object) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_CARD_ACCOUNTS_ARRAY,
            payload: value
        })
    }
}
export const setCCYName = (value:object) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_CCY_NAME,
            payload: value
        })
    }
}



export const getBlockedIbanData = (payload: any) => {

    const { company, ibanRef } = payload;

    return (dispatch: Dispatch<CardStatementAction>) => {
        return new Promise(() => {
            dispatch({ type: CardStatementActionTypes.GET_BLOCKED_IBAN_REQUEST })

            if (ibanRef) {
                getBlockedIbanService(company, ibanRef)
                    .then(response => {
                        dispatch({
                            payload: {
                                result: response,
                            },
                            type: CardStatementActionTypes.GET_BLOCKED_IBAN_SUCCESS,
                        })
                    })
                    .catch((error: any) => {
                        dispatch({
                            error: {
                                result: error.response,
                            },
                            type: CardStatementActionTypes.GET_BLOCKED_IBAN_ERROR,
                        })
                    })
            } else{
                dispatch({
                    payload: {
                        result: [],
                    },
                    type: CardStatementActionTypes.GET_BLOCKED_IBAN_SUCCESS,
                })
            }

        })
    }
}


// export const getAccountsData123 = (payload: any) => {
//
//     const { company } = payload;
//
//     return (dispatch: Dispatch<CardStatementAction>) => {
//         return new Promise(() => {
//             dispatch({ type: CardStatementActionTypes.GET_CARDS_DATA_REQUEST })
//             getAccounts(company)
//                 .then(response => {
//                     console.log(response)
//                     dispatch({
//                         payload: {
//                             result: response,
//                         },
//                         type: CardStatementActionTypes.GET_CARDS_DATA_SUCCESS,
//                     })
//                 })
//                 .catch((error: any) => {
//                     dispatch({
//                         error: {
//                             result: error.response,
//                         },
//                         type: CardStatementActionTypes.GET_CARDS_DATA_ERROR,
//                     })
//                 })
//
//         })
//     }
// }


export const setMoreDetail1 = (value:object) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_MORE_DETAIL,
            payload: value
        })
    }
}


export const setIbanNumber = (value:object) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_IBAN_NUMBER,
            payload: value
        })
    }
}


export const getRequisiteData1 = (payload: any) => {

    const { company, ibanRef } = payload;

    return (dispatch: Dispatch<CardStatementAction>) => {
        return new Promise(() => {
            dispatch({ type: CardStatementActionTypes.GET_REQUISITE_REQUEST })

            if (ibanRef) {
                getRequisite(company, ibanRef)
                    .then(response => {
                        dispatch({
                            payload: {
                                result: response,
                            },
                            type: CardStatementActionTypes.GET_REQUISITE_SUCCESS,
                        })
                    })
                    .catch((error: any) => {
                        dispatch({
                            error: {
                                result: error.response,
                            },
                            type: CardStatementActionTypes.GET_REQUISITE_ERROR,
                        })
                    })
            } else{
                dispatch({
                    payload: {
                        result: [],
                    },
                    type: CardStatementActionTypes.GET_REQUISITE_SUCCESS,
                })
            }

        })
    }
}


export const setAccountLoading = (value:boolean) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_CARD_LOADING,
            payload: value
        })
    }
}

export const setBalanceLoading = (value:boolean) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_BALANCE_LOADING,
            payload: value
        })
    }
}

export const setTransferWidgetLoading = (value:boolean) => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.SET_TRANSFER_WIDGET_LOADING,
            payload: value
        })
    }
}
export const clearCardArray = () => {
    return (dispatch: Dispatch<CardStatementAction>) => {
        dispatch({
            type: CardStatementActionTypes.CLEAR_CARD_ARRAY,
        })
    }
}